// extracted by mini-css-extract-plugin
export default {"box":"roVzuqaXP77e6y8fbS0E"};